var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hyper-cloud-console',{ref:"console",attrs:{"api":_vm.api,"autoOpen":_vm.autoOpen,"hideControls":_vm.hideControls,"customui":_vm.customui},on:{"userdataloaded":_vm.onUserDataLoaded,"accessgranted":_vm.onAccessGranted,"themechanged":_vm.onThemeChanged,"accessdenied":_vm.onAccessDenied}})
}
var staticRenderFns = []

export { render, staticRenderFns }